// ダーク / ライトテーマ。<html data-theme="..."> で CSS 変数を切り替える。
import { ref, watchEffect } from 'vue'

export type Theme = 'dark' | 'light'
const STORAGE_KEY = 'bpe.theme.v1'

function load(): Theme {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v === 'dark' || v === 'light') return v
  } catch {
    /* ignore */
  }
  return 'dark'
}

export const theme = ref<Theme>(load())

export function setTheme(t: Theme): void {
  theme.value = t
  try {
    localStorage.setItem(STORAGE_KEY, t)
  } catch {
    /* ignore */
  }
}

export function toggleTheme(): void {
  setTheme(theme.value === 'dark' ? 'light' : 'dark')
}

let installed = false
export function installTheme(): void {
  if (installed) return
  installed = true
  watchEffect(() => {
    document.documentElement.dataset.theme = theme.value
  })
}

export function useTheme() {
  return { theme, setTheme, toggleTheme }
}
